import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import "assets/scss/material-kit-react.scss?v=1.8.0";
import "assets/css/iese-site.css";
import "assets/css/iese-base-fonts.css";
import "assets/css/iese-base-colors.css";
import "assets/fonts/GraphikLCG/stylesheet.css";

// pages for this product
import MainPage from "./views/MainPage/MainPage";
import DigitalIdPage from './views/DigitalIdPage/DigitalIdPage';
import SucessPage from './views/SucessPage/SucessPage';
import ErrorPage from './views/ErrorPage/ErrorPage';
import ExemptPage from "./views/ExemptPage/ExemptPage";
import PersonalInformationPage from "./views/PersonalInformationPage/PersonalInformationPage";
import PaymentInfoPage from "./views/PaymentInfoPage/PaymentInfoPage";
import PaymentOverviewPage from "views/PaymentOverviewPage/PaymentOverviewPage";

// import PrivateRoute from "components/PrivateRoute/PrivateRoute";

import './i18n';

import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

var hist = createBrowserHistory();
var base64 = require('base-64');
var utf8 = require('utf8');

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path= "/help" component={ErrorPage}/>
      <Route path= "/success" component={SucessPage}/>
      <Route path= "/digitalid" component={DigitalIdPage}/>
      <Route path= "/exempt" component={ExemptPage}/>
      <Route path= "/personalinformation" component={PersonalInformationPage}/>
      <Route path= "/paymentmethod" component={PaymentInfoPage}/>
      <Route path= "/paymentoverview" component={PaymentOverviewPage}/>
      <Route path="/" component={MainPage}>
      </Route>

    </Switch>
  </Router>,
  document.getElementById("root")
);

//registerServiceWorker();
// Disable cache for Chrome compatibility on redirects. Source: https://stackoverflow.com/a/49605422
unregister();
